import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { StepId } from '../../api/useRiskToleranceWorkflowQuery';
import { Footer } from '../../components/Footer/Footer';
import { StepProps } from '../../components/OrionRiskToleranceWorkflow/OrionRiskToleranceWorkflow.meta';
import { FormValues, options, title } from './IncomeStability.meta';
import { Content } from '../../components/Content/Content';
import { StepCard } from '../../components/StepCard/StepCard';
import { VisualPicker } from '../../../CommonComponents/OPL/VisualPicker/VisualPicker';
import BoardRoomSVG from '../../../CommonComponents/OPL/illustrations/board-room.svg';

export const IncomeStability: React.FC<StepProps> = ({
  answers,
  onPrevious,
  onNext,
  onSubmit,
  progress,
}) => {
  const { handleSubmit, setValue, control } = useForm<FormValues>({
    defaultValues: {
      [StepId.IncomeStability]: answers.incomeStability,
    },
  });

  const onSubmitStep = ({ incomeStability }: FormValues) => {
    onSubmit({ stepId: StepId.IncomeStability, answer: incomeStability });
    onNext();
  };

  return (
    <Box minWidth={864}>
      <form onSubmit={handleSubmit(onSubmitStep)}>
        <Content>
          <StepCard title={title} textAlign="left">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Controller
                control={control}
                name={StepId.IncomeStability}
                render={({ field: { value: formValue } }) => (
                  <Box
                    display="flex"
                    flexDirection="column"
                    flexBasis={278}
                    gridGap="16"
                    role="radiogroup"
                    aria-label={title}
                  >
                    {options.map(({ label, value }) => {
                      const checked = value === formValue;

                      return (
                        <VisualPicker
                          key={value}
                          label={label}
                          onChange={() => setValue(StepId.IncomeStability, value)}
                          checked={checked}
                        />
                      );
                    })}
                  </Box>
                )}
              />

              <BoardRoomSVG width={259} height={264} />
            </Box>
          </StepCard>
        </Content>

        <Footer onPrevious={onPrevious} progress={progress} />
      </form>
    </Box>
  );
};
